import $ from 'jquery'

export function setUpTNTSlider() {
  $('.courses-slider')
    .owlCarousel({
      center: true,
      dots: true,
      autoplay: true,
      autoplayHoverPause: true,
      items: 1,
      margin: 50,
      rewind: true,
      lazyLoad: true,
      navContainer: '.tnt-slider-nav',
      navText: [$('.custom-prev'), $('.custom-next')],
      autoplayTimeout: 40000,
      responsive: {
        768: {
          autoplayTimeout: 20000
        }
      }
    })
    .on('changed.owl.carousel', function () {
      setTimeout(function () {
        $('.owl-item').removeClass('first-slide last-slide owl-first-or-last')
        if ($('.owl-item:first').hasClass('active')) {
          $('.owl-item:first').addClass('first-slide')
        }
        if ($('.owl-item:last').hasClass('active')) {
          $('.owl-item:last').addClass('last-slide')
        }
      }, 1)
    })

  $('.owl-prev,.owl-next').addClass('d-flex')
  $('.owl-prev').addClass('mr-2')
}
